export function getCookie(name) {
    const cookieVal = `;${document.cookie}`;
    const namePart = cookieVal.split(`;${name}=`)[1] ?? '';

    return decodeURIComponent(namePart.split(';')[0]);
}

